import * as React from "react";
import { forwardRef } from "react";
const SvgAvatar = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	fill: "none",
	viewBox: "0 0 32 32",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("mask", {
	id: "a",
	width: 32,
	height: 32,
	x: 0,
	y: 0,
	maskUnits: "userSpaceOnUse"
}, /* @__PURE__ */ React.createElement("path", {
	fill: "#E4E8F0",
	d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16z"
})), /* @__PURE__ */ React.createElement("g", { mask: "url(#a)" }, /* @__PURE__ */ React.createElement("path", {
	fill: "#E4E8F0",
	d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#8798AD",
	stroke: "#8798AD",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeMiterlimit: 10,
	d: "M20.87 10.713a4.868 4.868 0 0 1-5.774 4.786c-2.199-.404-3.966-2.783-3.966-5.023V9.001c0-2.24 1.753-4.633 3.966-5.022a4.868 4.868 0 0 1 5.774 4.786v1.948z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#8798AD",
	fillRule: "evenodd",
	d: "M26.884 27.727A15.943 15.943 0 0 1 16 32c-4.203 0-8.028-1.62-10.883-4.272l-.025-.027C6.873 23.694 11.09 20.869 16 20.869s9.127 2.825 10.908 6.832l-.024.026z",
	clipRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#8798AD",
	d: "M26.884 27.727l.34.367a.527.527 0 0 0 .035-.035l-.375-.332zm-21.767.001l-.374.332a.5.5 0 0 0 .034.035l.34-.367zm-.025-.027l-.457-.203a.5.5 0 0 0 .083.535l.374-.332zm21.816 0l.374.332a.5.5 0 0 0 .083-.535l-.457.203zM16 32.5c4.335 0 8.28-1.672 11.225-4.406l-.68-.733A15.443 15.443 0 0 1 16 31.5v1zM4.777 28.095A16.443 16.443 0 0 0 16 32.5v-1c-4.072 0-7.777-1.57-10.543-4.138l-.68.733zm.714-.698l-.025-.028-.748.664.025.027.748-.663zm.058.507c1.698-3.82 5.73-6.535 10.451-6.535v-1c-5.102 0-9.5 2.935-11.365 7.129l.914.406zM16 21.369c4.72 0 8.753 2.714 10.451 6.535l.914-.406C25.5 23.304 21.103 20.369 16 20.369v1zm10.534 6l-.024.026.749.664.023-.026-.748-.664z"
})));
const ForwardRef = forwardRef(SvgAvatar);
export { ForwardRef as ReactComponent };
